import React, { useCallback } from "react";
import { makeStyles } from "tss-react/mui";

import styles from "../../styles/jss/nextjs-material-kit/pages/articleStyle.js";

import Grid from "@mui/material/Grid";
import CustomInput from "../../components/CustomInput/CustomInput";
import Button from "../../components/CustomButtons/Button";
import { useRouter } from "next/router";

const dashboardRoutes = [];

const useStyles = makeStyles()(styles);

export default function AdviceSearch({ query, setQuery = undefined }) {
  const [keyword, setKeyword] = React.useState("");
  const router = useRouter();

  const handleSearch = useCallback(
    async (e) => {
      e.preventDefault();
      const path = router.asPath.split("?", 2)[0];

      window.gtag &&
      window.gtag("event", "advice_search", {
        search_term: keyword,
      });

      if (path === "/advice") {
        await router.push(`/advice/search?q=${encodeURIComponent(keyword)}`);
      } else {
        await router.push(`${path}?q=${encodeURIComponent(keyword)}`);
      }
    },
    [keyword]
  );

  const { classes, cx } = useStyles();
  return (
    <>
      <form className={classes.container} onSubmit={handleSearch}>
        <Grid container className={classes.paddingZero}>
          <Grid item xs={12} sm={12} md={12} className={classes.paddingZero}>
            <h1 className={cx(classes.title, "title")}>Advice</h1>
            <div
              id="inputs"
              className={[classes.search_section, "search_section"].join(" ")}
            >
              <div className={classes.searchbox_title}>
                Search for the latest advice
              </div>
              <Grid
                container
                style={{ alignItems: "center", padding: "15px 0" }}
                spacing={2}
              >
                <Grid item xs={12} sm={9} md={9} lg={9}>
                  <CustomInput
                    inputProps={{
                      value: keyword || query,
                      placeholder: "Keywords, topic, question",
                      onChange: (e) => setKeyword(e.target.value),
                      className: cx(
                        classes.inputField,
                        "whatField",
                        "whatField-1"
                      ),
                    }}
                    homeSearchBaseInput
                    homeSearch
                    id="advice-search-term"
                    formControlProps={{
                      fullWidth: true,
                      fontSize: "18px",
                    }}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={3}
                  lg={3}
                  className={cx(classes.paddingZero, classes.marginBottom8)}
                >
                  <Button
                    type="submit"
                    className={cx(classes.homeSearchButton)}
                    fullWidth
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </div>
            <div className={classes.space70} />
            <br />
          </Grid>
        </Grid>
      </form>
    </>
  );
}
